import { Button, Modal } from "antd";
import React, { JSX, useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";

type Props = {
  children: JSX.Element;
  open: boolean;
  onClose: () => void;
};
const BillModal = ({ children, open, onClose }: Props) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef, onAfterPrint: onClose });

  useEffect(() => {
    if (open) {
      reactToPrintFn();
    }
  }, [open]);

  return (
    <>
      {/* <Button size="large" className="w-full mt-3" onClick={toggle}>
        Print Bill Copy
      </Button> */}
      <Modal
        open={open}
        onCancel={onClose}
        centered
        style={{ padding: "0" }}
        title="Recipt"
        okText="Print Recipt"
        onOk={reactToPrintFn}
      >
        <div ref={contentRef} style={{ width: "400px" }} className="mx-auto">
          {children}
        </div>
      </Modal>
    </>
  );
};

export default BillModal;
